/*
 * Gift Baskets To Miami: size gallery.
 * Used only on products whose sizes each have their own photo
 * (product-media-gallery adds data-gbm-size-gallery to <media-gallery>).
 *  - Photos keep their admin order: the selected size's photo is shown, not moved to the front.
 *  - The photo shown and the selected size always match: choosing a size shows its photo,
 *    and tapping a size photo (or swiping to it on mobile) selects that size.
 */
(() => {
  if (window.gbmSizeGallery) return;
  window.gbmSizeGallery = true;

  const GALLERY = 'media-gallery[data-gbm-size-gallery]';
  const mobile = window.matchMedia('(max-width: 749px)');

  // Keep the order: never prepend the selected size's photo in a size gallery.
  customElements.whenDefined('media-gallery').then(() => {
    const proto = customElements.get('media-gallery').prototype;
    if (proto.gbmKeepOrder) return;
    const setActiveMedia = proto.setActiveMedia;
    proto.setActiveMedia = function (mediaId, prepend) {
      return setActiveMedia.call(this, mediaId, this.hasAttribute('data-gbm-size-gallery') ? false : prepend);
    };
    proto.gbmKeepOrder = true;
  });

  const optionValuesFor = (gallery, mediaId) => {
    const item = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]')).find(
      (el) => el.dataset.target === mediaId
    );
    const label = item && item.querySelector('.gbm-size-label');
    if (!label) return null;
    try {
      return JSON.parse(label.dataset.gbmOptions);
    } catch (error) {
      return null;
    }
  };

  // Select the size (option values) that a photo stands for, through the theme's own size picker.
  const selectSizeFor = (gallery, mediaId) => {
    const values = optionValuesFor(gallery, mediaId);
    if (!values || !values.length) return;
    const scope = gallery.closest('product-info') || document;
    const picker = scope.querySelector('variant-selects');
    if (!picker) return;
    const groups = picker.querySelectorAll('fieldset, .product-form__input--dropdown');

    values.forEach((value, index) => {
      const group = groups[index];
      if (!group) return;
      const select = group.querySelector('select');
      if (select) {
        const option = Array.from(select.options).find((o) => o.value === value);
        if (!option || option.selected) return;
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((r) => r.value === value);
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  // Tapping a size photo or its label selects that size.
  document.addEventListener('click', (event) => {
    const item = event.target.closest(`${GALLERY} .thumbnail-list__item[data-target]`);
    if (!item) return;
    const gallery = item.closest('media-gallery');
    if (event.target.closest('.gbm-size-label') && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(item.dataset.target, false);
    }
    selectSizeFor(gallery, item.dataset.target);
  });

  const init = (gallery) => {
    if (gallery.dataset.gbmReady) return;
    gallery.dataset.gbmReady = 'true';

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const list = viewer && viewer.querySelector('.product__media-list');
    if (!list) return;

    // Open on the selected size's photo (e.g. a link to the Deluxe size).
    const active = list.querySelector('.product__media-item.is-active');
    if (active && active !== list.firstElementChild) {
      list.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
    }

    // On mobile, swiping to a size photo selects that size.
    let timer;
    viewer.addEventListener('slideChanged', (event) => {
      clearTimeout(timer);
      const current = event.detail && event.detail.currentElement;
      timer = setTimeout(() => {
        if (!mobile.matches || !current || !current.dataset.mediaId) return;
        selectSizeFor(gallery, current.dataset.mediaId);
      }, 600);
    });
  };

  const initAll = () => document.querySelectorAll(GALLERY).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
